module.exports = __webpack_public_path__ + "static/media/w_w_hw_0.881d0b83.png";